"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Video = function Video() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.9 7.8C3.9 7.27927 4.34324 6.85714 4.89 6.85714H19.11C19.6568 6.85714 20.1 7.27927 20.1 7.8V16.2C20.1 16.7207 19.6568 17.1429 19.11 17.1429H4.89C4.34324 17.1429 3.9 16.7207 3.9 16.2V7.8ZM4.89 6C3.84618 6 3 6.80589 3 7.8V16.2C3 17.1941 3.84618 18 4.89 18H19.11C20.1538 18 21 17.1941 21 16.2V7.8C21 6.80589 20.1538 6 19.11 6H4.89ZM10.2181 8.79175C10.0789 8.71515 9.90733 8.71513 9.76808 8.79168C9.62882 8.86823 9.54303 9.00972 9.54303 9.16285V14.8371C9.54303 14.9903 9.62882 15.1318 9.76808 15.2083C9.90733 15.2849 10.0789 15.2848 10.2181 15.2082L15.3751 12.3711C15.5143 12.2945 15.6 12.1531 15.6 12C15.6 11.8469 15.5143 11.7055 15.3751 11.6289L10.2181 8.79175ZM14.2504 12L10.443 14.0946V9.90536L14.2504 12Z"
    })
  });
};
exports.Video = Video;